<template>
  <div class="main_content_top section_bottom recommend_box">
    <el-row :gutter="20" class="top_row">
      <el-col :span="12" align="left">
        <img class="md" src="../../assets/images/icon_13.png" alt="" />
        <img
          class="hd"
          src="../../assets/images/icon_13.png"
          alt=""
          style="width: 3px; height: 16px; vertical-align: text-top"
        />
        <span>推荐阅读</span>
      </el-col>
      <router-link
        :to="{
          name: '通用更多',
          query: {
            commonMoreName: '推荐阅读',
            showType: 'list',
            activeMenu: '推荐阅读'
          }
        }"
      >
        <el-col :span="12" align="right" class="desc hidden-md-and-down"
          >学海无涯 学无止境</el-col
        >
      </router-link>
      <router-link
        :to="{
          name: '通用更多',
          query: {
            commonMoreName: '推荐阅读',
            showType: 'list',
            activeMenu: '推荐阅读'
          }
        }"
      >
        <el-col :span="12" class="more hidden-lg-and-up" align="right">
          <img src="@/assets/images/phone/sub_more.png" alt="" />
        </el-col>
      </router-link>
    </el-row>
    <div class="recommend">
      <el-row>
        <el-col
          :sm="24"
          :lg="8"
          :span="24"
          v-for="(item, index) in recommendList"
          :key="index"
          @click.native="handleClickOne(item)"
          >{{ item.readName }}</el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
  import { getRead } from "@/api/home"
  export default {
    name: "home_recommend", //首页-推荐阅读
    data() {
      return {
        recommendList: []
      }
    },
    created() {
      this.handleQuery()
    },
    mounted() {},
    methods: {
      handleQuery() {
        getRead().then((res) => {
          this.recommendList = res.data.data
        })
      },
      handleClickOne(item) {
        const apiUrl =
          process.env.VUE_APP_BASE_API +
          `/web/portal/read/get/one?id=${item.id}`
        const activeMenu = "推荐阅读"
        this.$store.commit("SET_API_URL", apiUrl)
        const payload = {
          activeParentMenu: "推荐阅读",
          activeMenu: activeMenu
        }
        this.$store.commit("SET_ACTIVE_MENU", payload)
        this.$router.push({
          path: "/commonShow"
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .recommend {
    padding: 20px;
    margin-top: 24px;
    /* height: 257px; */
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 12px 0px rgba(168, 168, 168, 0.46);
    font-size: 20px;
    color: #333333;
  }
  .recommend .el-row .el-col {
    text-align: left;
    line-height: 40px;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .recommend .el-row .el-col::after {
    content: "";
    display: block;
    width: 20px;
    height: 6px;
    background-color: #868686;
    position: absolute;
    left: 0;
    top: 15px;
  }
  .recommend_box {
    .top_row {
      .md {
        display: inline-block;
      }
      .hd {
        display: none;
      }
    }
  }
  @media (max-width: 768px) {
    .recommend {
      font-size: 12px;
      box-shadow: none;
      padding: 0;
      height: auto;
    }
    .recommend .el-row .el-col {
      padding-left: 0;
      border-bottom: solid 1px #e8e8e8;
    }
    .recommend .el-row .el-col::after {
      content: none;
    }
    .recommend_box {
      .top_row {
        .md {
          display: none;
        }
        .hd {
          display: inline-block;
        }
      }
    }
  }
</style>
